<template>
  <basic-dialog :show="show" @close="$emit('close')" maxWidth="700">
    <template v-slot:title>Service Note</template>
    <v-row>
      <v-col>
        <dates-range-picker
          :gtDateFromString="dateFrom"
          :gtDateToString="dateTo"
          @onRangeSelected="onDateRangeSelected"
          :outlined="outlinedInputs"
        ></dates-range-picker>
      </v-col>
      <v-col>
        <gt-multi-select
          label="Service"
          :outlined="outlinedInputs"
          hide-details
          v-model="selectedServices"
          :items="inUseServices"
          item-text="node.name"
          item-value="node.id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <agent-group-select v-model="groupId" :outlined="outlinedInputs" />
      </v-col>
      <v-col>
        <department-list-select
          v-model="department"
          :outlined="outlinedInputs"
          show-all
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea v-model="description" :outlined="outlinedInputs" />
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ services }}</code>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onSave">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import { sortByFn } from "../../../../helpers";
import AgentGroupSelect from "../../shared/AgentGroupSelect.vue";
import BasicDialog from "../../shared/BasicDialog.vue";
import DatesRangePicker from "../../shared/DatesRangePicker.vue";
import DepartmentListSelect from "../../shared/DepartmentListSelect.vue";
import GtMultiSelect from "../../shared/GtMultiSelect.vue";
export default {
  name: "service-notes-edit-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    services: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
    DatesRangePicker,
    GtMultiSelect,
    AgentGroupSelect,
    DepartmentListSelect,
  },

  data: () => ({
    debug: false,
    dateFrom: this.value ? this.value.dateFrom : "",
    dateTo: this.value ? this.value.dateTo : "",
    description: this.value ? this.value.description : "",
    selectedServices: this.value ? [...this.value.services] : [],
    groupId: this.value ? this.value.groupId : "",
    department: this.value ? this.value.department : "",
    description: this.value ? this.value.description : "",
  }),

  computed: {
    inUseServices() {
      return this.services
        .filter((s) => !s.node.notInUse)
        .sort(sortByFn((item) => item.node.name.toString()));
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return (
        this.dateFrom != "" &&
        this.dateTo != "" &&
        this.selectedServices.length > 0 &&
        this.department != "" &&
        this.description != ""
      );
    },
  },

  watch: {
    value(newVal) {
      this.dateFrom = newVal ? newVal.dateFrom : "";
      this.dateTo = newVal ? newVal.dateTo : "";
      this.description = newVal ? newVal.description : "";
      this.selectedServices = newVal ? [...newVal.services] : [];
      this.groupId = newVal ? newVal.groupId : "";
      this.department = newVal ? newVal.department : "";
      this.description = newVal ? newVal.description : "";
    },
  },

  methods: {
    onDateRangeSelected(payload) {
      this.dateFrom = payload.dateFrom;
      this.dateTo = payload.dateTo;
    },
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        groupId: this.groupId,
        department: this.department,
        description: this.description,
        services: [...this.selectedServices],
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/service-notes/ServiceNotesEditDialog.vue